import React from 'react';
import * as sanity from '../../../sanity-image';
import { SanityFigure } from '../../../../graphql-types';
import { getDimensionsFromSanityImage } from '../../../helpers/get-dimensions';

type SanityImageProps = {
    className?: string;
    image: SanityFigure;
    sizes?: string;
    loading?: 'lazy' | 'eager';
};

export function SanityImage({ className, image, sizes, loading = 'lazy' }: SanityImageProps) {
    if (!image || !image.asset?.url) {
        return null;
    }

    const { width, height } = getDimensionsFromSanityImage(
        image.asset.metadata?.dimensions?.width ?? 0,
        image.asset.metadata?.dimensions?.height ?? 0,
        image.crop
    );

    return (
        <img
            loading={loading}
            className={className}
            width={width}
            alt={image.altText || ''}
            height={height}
            src={sanity.urlFor(image).url() || ''}
            sizes={sizes}
        />
    );
}
